import { useMemo } from "react";

import { Typo } from "../../../Typo";
import { BarChartData } from "../../Common/BarChart";
import { ReturnedTranslatedContentClientsPageHook } from "../../types";

type InstrumentChartMiniProps = {
  data: (BarChartData & { volumeUSD: string })[];
  translatedContent: ReturnedTranslatedContentClientsPageHook["translatedContent"];
};

export const InstrumentChartMini = ({
  data,
  translatedContent,
}: InstrumentChartMiniProps) => {
  const barsData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const maxClients = Math.max(
      ...data.map((item) => item.clientCount ?? 0),
      1,
    );

    return data.map((item) => ({
      ...item,
      percentage: ((item.clientCount ?? 0) / maxClients) * 100,
    }));
  }, [data]);

  if (barsData.length === 0) return null;

  const topInstrument = data[0];

  return (
    <div className="flex flex-row items-center justify-between gap-4">
      <div className="flex flex-shrink-0 flex-col gap-1">
        <Typo type="labelSM" textColor="text-text-secondary">
          {translatedContent.graphs.tradedInstrumentsClass}
        </Typo>
        <Typo element="h4" type="headingMD">
          {topInstrument.label}
        </Typo>
      </div>

      <div className="flex w-[57px] flex-shrink-0 flex-col gap-1">
        {barsData.slice(0, 5).map((item, index) => (
          <div
            key={item.label}
            className="bg-surface-tonal-subtle h-1.5 overflow-hidden rounded-full"
            style={{ opacity: 1 - index * 0.15 }}
          >
            <div
              className="h-full rounded-full transition-all duration-300"
              style={{
                width: `${item.percentage}%`,
                backgroundColor: item.color || "#0066FF",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
